(function () {
  'use strict';

  class BIReportCtrl {
    constructor($scope, $log, Keys, ServiceVfiltro, FactoryVfiltro, Authenticator, safetyService) {
      this.scope = $scope;
      this.log = $log;
      this.authenticator = Authenticator;
      this.serviceVfiltro = ServiceVfiltro;
      this.safetyService = safetyService;
      this.componentId = 'safety-bi-report';

      this.serviceVfiltro.init(FactoryVfiltro.get([
        {
          key: Keys.uo.name
        }
      ]))
      .then((filtro) => {
        this.vfiltroBackend = this.serviceVfiltro.getFiltroBackendNovo(filtro);

        this.loadSafety();
      });
    }

    loadSafety() {
      this.authenticator.getUser().then(user => {
        const appName = 'safetyApp',
            componentPath = './BIReport',
            props = {
              user: user,
              uoId: this.vfiltroBackend.uo_permissao
            };

        this.safetyService
          .loadReactComponent(appName, componentPath, this.componentId, props)
          .catch(error => this.log.error('Error loading:', error));
      });
    }
  }

  angular
    .module('biReport')
    .controller('BIReportCtrl', BIReportCtrl);
}());
